import { render, staticRenderFns } from "./ProjectApplicantDetail.vue?vue&type=template&id=77f960ac&scoped=true&"
import script from "./ProjectApplicantDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectApplicantDetail.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-applicant-detail.scss?vue&type=style&index=0&id=77f960ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f960ac",
  null
  
)

export default component.exports